import * as Sentry from "@sentry/react";
import { resetAnalyticsIdentity } from "./utils/analyticsIdentity";
import { hideFrontChatWidget } from "./utils/frontChatUtils";

let generation = 0;

// fetchDashboard compares this before and after its request, so a response
// from a session that has since ended doesn't set that session's effects up again
export const currentSessionGeneration = () => generation;

// Each step is attempted on its own, so a third-party script that throws
// doesn't leave the rest of the last session in place
const attempt = (step, fn) => {
  try {
    fn();
  } catch (err) {
    console.error(`Ending the session: ${step} failed`, err);
  }
};

// Undoes fetchDashboard's side effects. Leaves the query cache alone, so it's
// safe while a dashboard query is still mounted and enabled.
export function endSessionEffects() {
  generation += 1;
  attempt("Front Chat", hideFrontChatWidget);
  // Sentry has no call that removes a tag. An undefined value stays on the
  // scope, but the event envelope's JSON.stringify drops it.
  attempt("Sentry tags", () =>
    Sentry.setTags({ session_type: undefined, subject_type: undefined, dashboard_background_refresh: undefined }),
  );
  attempt("analytics identity", resetAnalyticsIdentity);
}

export function resetSession(queryClient) {
  endSessionEffects();
  attempt("query cache", () => queryClient.clear());
}
